import { useQuery } from "@tanstack/react-query";
import { masterService } from "@/services/master.service";

export const masterKey = {
  all: ["master"] as const,
  streams: () => [...masterKey.all, "streams"] as const,
  collegeDegrees: (deptId: string) => [...masterKey.all, "college-degrees", deptId] as const,
};

export const useStreamsQuery = () =>
  useQuery({
    queryKey: masterKey.streams(),
    queryFn: () => masterService.fetchStreams(),
  });
